window.bundleDataK = {
"Kai-girl": {
displayName: "Kai",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kai Personalized Coloring Experience",
variantId: "49537903821037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kai_final_cover_2f7324ed-d4a8-48fb-891f-54c3950a8cb0.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Kai Unicorn Holographic Sticker",
variantId: "49933757284589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kai_holographic_sticker_fcc17235-f1ff-40c4-92f8-1b9d89ab48e5.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kai Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kai-boy": {
displayName: "Kai",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kai Personalized Coloring Experience",
variantId: "49400167039213",
image: "https://lkbunting.com/cdn/shop/files/KAI_FINAL_COVER.png?v=1771691585&width=600",
price: "$14.99",
preorder: true
},
{
title: "Kai Dragon Holographic Sticker",
variantId: "49933769081069",
image: "https://lkbunting.com/cdn/shop/files/Kai_holographic_sticker.png?v=1779648205&width=600",
price: "$4.99",
preorder: false
},
{
title: "Kai Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kaia-girl": {
displayName: "Kaia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaia Personalized Coloring Experience",
variantId: "49339336294637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaia_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Kaia Unicorn Holographic Sticker",
variantId: "49933772423405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaia_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kaia Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kaitlyn-girl": {
displayName: "Kaitlyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaitlyn Personalized Coloring Experience",
variantId: "49402686734573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KAITLYNFINALCOVER.png?v=1771819186",
price: "$14.99",
preorder: true
},
{
title: "Kaitlyn Unicorn Holographic Sticker",
variantId: "49933768130797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaitlyn_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kaitlyn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kamila-girl": {
displayName: "Kamila",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kamila Personalized Coloring Experience",
variantId: "49537853718765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kamila_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Kamila Unicorn Holographic Sticker",
variantId: "49933757382893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kamila_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kamila Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Karol-girl": {
displayName: "Karol",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Karol Personalized Coloring Experience",
variantId: "49983107039469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Karolfinalcover.png?v=1779026864",
price: "$14.99",
preorder: true
},
{
title: "Karol Unicorn Holographic Sticker",
variantId: "49983096029421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Karol_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Karol Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kate-girl": {
displayName: "Kate",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kate Personalized Coloring Experience",
variantId: "49731903619309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kate_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Kate Unicorn Holographic Sticker",
variantId: "49933753286893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kate_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Kate Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Katherine-girl": {
displayName: "Katherine",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Katherine Personalized Coloring Experience",
variantId: "49537404731629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Katherine_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Katherine Unicorn Holographic Sticker",
variantId: "49933757481197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Katherine_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Katherine Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kayden-boy": {
displayName: "Kayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kayden Personalized Coloring Experience",
variantId: "49402607993069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KAYDENFINALCOVER.png?v=1771816039",
price: "$14.99",
preorder: true
},
{
title: "Kayden Dragon Holographic Sticker",
variantId: "49933768851693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kayden_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Kayden Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kayla-girl": {
displayName: "Kayla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kayla Personalized Coloring Experience",
variantId: "49571502129389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kayla_final_cover.png?v=1773281879",
price: "$14.99",
preorder: true
},
{
title: "Kayla Unicorn Holographic Sticker",
variantId: "49933756825837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kayla_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Kayla Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kaylee-girl": {
displayName: "Kaylee",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaylee Personalized Coloring Experience",
variantId: "49567524913389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kayleefinalfinalcover.png?v=1773325342",
price: "$14.99",
preorder: true
},
{
title: "Kaylee Unicorn Holographic Sticker",
variantId: "49933757251821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaylee_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Kaylee Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kelsey-girl": {
displayName: "Kelsey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kelsey Personalized Coloring Experience",
variantId: "49279569887469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kelsey_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Kelsey Unicorn Holographic Sticker",
variantId: "49933775306989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kelsey_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Kelsey Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kennedy-girl": {
displayName: "Kennedy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kennedy Personalized Coloring Experience",
variantId: "49571466117357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kennedyfinalfinalcover.png?v=1773356022",
price: "$14.99",
preorder: true
},
{
title: "Kennedy Unicorn Holographic Sticker",
variantId: "49933756989677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kennedy_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kennedy Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kevin-boy": {
displayName: "Kevin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kevin Personalized Coloring Experience",
variantId: "49402617495789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KEVINFINALCOVER.png?v=1771816190",
price: "$14.99",
preorder: true
},
{
title: "Kevin Dragon Holographic Sticker",
variantId: "49933768818925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kevin_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Kevin Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kiara-girl": {
displayName: "Kiara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kiara Personalized Coloring Experience",
variantId: "49571485679853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kiara_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Kiara Unicorn Holographic Sticker",
variantId: "49933756956909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kiara_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Kiara Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kieran-boy": {
displayName: "Kieran",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kieran Personalized Coloring Experience",
variantId: "49351808483565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kieran_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "Kieran Dragon Holographic Sticker",
variantId: "49933770588397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kieran_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Kieran Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kimberly-girl": {
displayName: "Kimberly",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kimberly Personalized Coloring Experience",
variantId: "49571493904621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kimberly_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Kimberly Unicorn Holographic Sticker",
variantId: "49933756924141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kimberly_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kimberly Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"King-boy": {
displayName: "King",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "King Personalized Coloring Experience",
variantId: "49402678608109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KINGFINALCOVER.png?v=1771818563",
price: "$14.99",
preorder: true
},
{
title: "King Dragon Holographic Sticker",
variantId: "49933768327405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/King_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "King Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kit-boy": {
displayName: "Kit",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kit Personalized Coloring Experience",
variantId: "49709393510637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kit_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Kit Dragon Holographic Sticker",
variantId: "49933753745645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kit_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Kit Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Knox-boy": {
displayName: "Knox",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Knox Personalized Coloring Experience",
variantId: "49274703675629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Knox_final_cover.png?v=1772677735",
price: "$14.99",
preorder: true
},
{
title: "Knox Dragon Holographic Sticker",
variantId: "49933780517101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Knox_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Knox Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kolton-boy": {
displayName: "Kolton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kolton Personalized Coloring Experience",
variantId: "49402620477677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KOLTON_FINAL_COVER_69850a94-36e8-483c-bca3-4a7cfd5b3986.png?v=1771816357",
price: "$14.99",
preorder: true
},
{
title: "Kolton Dragon Holographic Sticker",
variantId: "49933768786157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kolton_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Kolton Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Krystal-girl": {
displayName: "Krystal",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Krystal Personalized Coloring Experience",
variantId: "49983108907245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Krystalfinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Krystal Unicorn Holographic Sticker",
variantId: "49983081939181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Krystal_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Krystal Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kyle-boy": {
displayName: "Kyle",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kyle Personalized Coloring Experience",
variantId: "49411999432941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/KYLE_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Kyle Dragon Holographic Sticker",
variantId: "49933766885613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kyle_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Kyle Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Kylie-girl": {
displayName: "Kylie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kylie Personalized Coloring Experience",
variantId: "49571410870509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kylie_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Kylie Unicorn Holographic Sticker",
variantId: "49933757153517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kylie_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Kylie Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Kyrie-girl": {
displayName: "Kyrie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kyrie Personalized Coloring Experience",
variantId: "49571503833325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kyrie_final_cover.png?v=1773281879",
price: "$14.99",
preorder: true
},
{
title: "Kyrie Unicorn Holographic Sticker",
variantId: "49933756793069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kyrie_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Kyrie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Kinsley-girl": {
displayName: "Kinsley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kinsley Personalized Coloring Experience",
variantId: "50056827994349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kinsley_final_cover.png?v=1780209146",
price: "$14.99",
preorder: true
},
{
title: "Kinsley Unicorn Holographic Sticker",
variantId: "50056985968877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kinsley_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Kinsley Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Kingston-boy": {
displayName: "Kingston",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kingston Personalized Coloring Experience",
variantId: "50126131724525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kingston_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Kingston Dragon Holographic Sticker",
variantId: "50127069348077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kingstonstickerwebsite.png?v=1781967505",
price: "$4.99",
preorder: false
},
{
title: "Kingston Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kaiden-boy": {
displayName: "Kaiden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaiden Personalized Coloring Experience",
variantId: "50127689515245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaidenfinalcover.png?v=1781987845",
price: "$14.99",
preorder: true
},
{
title: "Kaiden Dragon Holographic Sticker",
variantId: "50127668936941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaidenwebsitesticker.png?v=1781986891",
price: "$4.99",
preorder: false
},
{
title: "Kaiden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kehlani-girl": {
displayName: "Kehlani",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kehlani Personalized Coloring Experience",
variantId: "50245889097965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kehlani_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Kehlani Unicorn Holographic Sticker",
variantId: "50259965509869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kehlani_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Kehlani Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Khloe-girl": {
displayName: "Khloe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Khloe Personalized Coloring Experience",
variantId: "50305417380077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Khloe_final_cover.png?v=1784423758",
price: "$14.99",
preorder: true
},
{
title: "Khloe Unicorn Holographic Sticker",
variantId: "50305507524845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Khloe_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Khloe Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Karter-boy": {
displayName: "Karter",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Karter Personalized Coloring Experience",
variantId: "50399093326061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Karter_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Karter Dragon Holographic Sticker",
variantId: "50399513411821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Karter_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Karter Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kyrie-boy": {
displayName: "Kyrie",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kyrie Personalized Coloring Experience",
variantId: "50399268667629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kyrie_final_cover_9e6e1259-f387-49a1-aa72-f91111172736.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Kyrie Dragon Holographic Sticker",
variantId: "50399552078061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kyrie_boy_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Kyrie Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kaleb-boy": {
displayName: "Kaleb",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaleb Personalized Coloring Experience",
variantId: "50399764513005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kalebfinalcover.png?v=1785904320",
price: "$14.99",
preorder: true
},
{
title: "Kaleb Dragon Holographic Sticker",
variantId: "50449538515181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaleb_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Kaleb Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kairo-boy": {
displayName: "Kairo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kairo Personalized Coloring Experience",
variantId: "50449680531693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kairo_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Kairo Dragon Holographic Sticker",
variantId: "50449571709165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kairo_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Kairo Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kenneth-boy": {
displayName: "Kenneth",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kenneth Personalized Coloring Experience",
variantId: "50449686331629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kenneth_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Kenneth Dragon Holographic Sticker",
variantId: "50449580523757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kenneth_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Kenneth Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kash-boy": {
displayName: "Kash",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kash Personalized Coloring Experience",
variantId: "50457710264557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kash_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Kash Dragon Holographic Sticker",
variantId: "50457540919533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kash_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Kash Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Kaden-boy": {
displayName: "Kaden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Kaden Personalized Coloring Experience",
variantId: "50457729859821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaden_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Kaden Dragon Holographic Sticker",
variantId: "50457697714413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Kaden_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Kaden Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} 




 



};